import { useEffect, useRef, useState } from "react";
import axios from "axios";
import "../../Styles/auth/auth.scss";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import isoEventLogo from "./../../assets/images/Logo/Logo-Pazirex-Blue.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginStep from "../../utilities/functions/loginProcessStep";
import AuthFooter from "../../components/AuthFooter";
import useCenteredPage from "../../Hooks/useCenteredPage";

const Login = () => {

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const loginWrapperRef = useRef()

    useCenteredPage(loginWrapperRef)

    const [phoneNumber, setPhoneNumber] = useState("");

    const apiParams = { mobile: phoneNumber }

    const referrer_id = localStorage.getItem('referrer_id')

    if (referrer_id) {
        apiParams.referrer_id = referrer_id
    }

    const loginAPI = (e) => {

        e.preventDefault(); // Prevent form submission
        setLoading(true);

        axios
            .post(serverConfig.server.url + apiConfig.api.authControllers.login, apiParams)
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    localStorage.setItem("tokenfa", response.data.data.token);
                    localStorage.setItem("mobile", phoneNumber);
                    response.data.data.verification_code &&
                        toast.success("کد ارسالی " + response.data.data.verification_code);
                    toast.success("پیامک حاوی کد تایید با موفقیت ارسال شد");
                    navigate("/twofa");
                } else {
                    if (typeof response.data.errors === 'string') {

                        // remove the invalid referre_id and re-call the login route again
                        if (response?.data?.errors === 'چنین سایتی وجود ندارد!') {
                            localStorage.removeItem('referrer_id')
                            loginAPI()
                            return
                        }

                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });

    };

    useEffect(() => {
        let step = LoginStep();
        if (step !== "OK" && step) navigate(step)
    }, []);

    return (

        <section ref={loginWrapperRef} className="tw-flex tw-items-center tw-justify-center tw-pt-3 tw-max-w-full md:tw-max-w-[500px] tw-m-auto">

            <div className="card-body border-gray-400 tw-rounded-2xl tw-border-0 md:tw-border tw-p-5 md:tw-p-8">

                <img
                    src={isoEventLogo}
                    className="logo-img d-flex mx-auto tw-w-[55%] tw-h-auto tw-mb-12"
                    alt="..."
                />

                <h5 className="card-title tw-font-medium tw-text-[20px] tw-text-[#212529] tw-mb-2">ثبت نام یا ورود</h5>
                <p className="tw-font-normal tw-text-[#495057] tw-text-[16px]">
                    لطفا شماره همراه خود را وارد کنید ، کد تأیید به این شماره پیامک
                    خواهد شد.
                </p>
                <form onSubmit={loginAPI}>
                    <input
                        type="tel"
                        style={{ border: '1px solid #CED4DA' }}
                        className="tw-w-full tw-p-2 tw-rounded-lg tw-bg-white tw-outline-none"
                        id="phoneNumber"
                        placeholder="شماره همراه"
                        value={phoneNumber}
                        onChange={(e) => {
                            setPhoneNumber(e.target.value);
                        }}
                        autoFocus
                    />
                    <button
                        className="btn btn-primary tw-mt-2 tw-w-full"
                        type="submit"
                        disabled={loading || !phoneNumber}
                    >
                        تایید و دریافت کد
                        {loading && (
                            <span
                                className="spinner-border spinner-border-sm ms-1"
                                role="status"
                                aria-hidden="true"
                            />
                        )}
                    </button>
                </form>
                <AuthFooter />
            </div>
        </section>
    );
};

export default Login;
